// @ts-ignore
import { fetchFares } from "@store/services/fetchCheckoutData";
import { ActionTree } from "vuex";
import { IStore } from "@store/index";
import { FaresState } from "./index";
import { AxiosError, AxiosResponse } from "axios";
import Fare from "./interfaces/fare";
import { FARE_DEFAULT } from "@constants/fares";

export default {
    async getAvailableFares({ state, commit, dispatch, rootState }) {
        await fetchFares(
            rootState.checkout.apiEndpoint,
            rootState.checkout.checkoutSummary.tripId,
            rootState.checkout.checkoutSettings.appointmentHash,
            rootState.checkout.apiToken,
            rootState.checkout.checkoutSettings.sessionId,
            rootState.checkout.checkoutSettings.departureAirport,
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('setAvailableFares', response.data.fares);

                if (shouldUpdateFare(state, rootState)) {
                    // By default, the cheapest fare is preselected
                    const cheapestFare: Fare | undefined = state.availableFares.find((fare: Fare) => fare.isCheapest)

                    dispatch('updateFare', cheapestFare?.fare)
                    dispatch('funnel/addSelectedToCheckoutFunnel', { type: 'fare', picked: cheapestFare }, { root: true })
                }
            })
            .catch((e: AxiosError) => {
                const responseStatus = e.response ? e.response.status : 'none';
                const message = `Error in getAvailableFares | Error code: 1655209067 | HTTP status: ${responseStatus} | ${e.message}`;

                dispatch('openErrorOverlay');

                throw Error(message);
            });
    },
} as ActionTree<FaresState, IStore>

function shouldUpdateFare(state: FaresState, rootState: IStore) {
    return state.availableFares.length > 0
        && rootState.checkout.fare === FARE_DEFAULT
        && rootState.checkout.checkoutSettings.restoreId === '';
}
